/**
 * <article-author> — mobile placement for sections/article-author.liquid.
 *
 * On the recipe template the mobile frame (5326:5244) runs steps, video, note,
 * then the author card, then the per-serve and shop cards. The template prints
 * this section after the whole recipe body, so below 769px the card is moved
 * to the end of .recipe-body__main, after the note (or the video, or the
 * Method, whichever is last there). The note and video sections park
 * themselves with `after()` on the element before them, so whichever script
 * runs first, the card still ends up last.
 *
 * Pages without a recipe body (the standard article template) have no anchor,
 * so the card stays where it is. From 769px up it returns to this section.
 * The move is undone before a theme-editor reload removes the section.
 */
if (!customElements.get('article-author')) {
  customElements.define(
    'article-author',
    class ArticleAuthor extends HTMLElement {
      constructor() {
        super();
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.onSectionUnload = this.onSectionUnload.bind(this);
      }

      connectedCallback() {
        this.card = this.querySelector('.article-author__card');
        this.home = this.card?.parentNode ?? null;
        this.section = this.closest('.shopify-section');
        this.layoutQuery = window.matchMedia('(max-width: 768px)');
        this.layoutQuery.addEventListener('change', this.onLayoutChange);
        this.section?.addEventListener('shopify:section:unload', this.onSectionUnload);
        this.place();
      }

      disconnectedCallback() {
        this.layoutQuery?.removeEventListener('change', this.onLayoutChange);
        this.section?.removeEventListener('shopify:section:unload', this.onSectionUnload);
      }

      onLayoutChange() {
        this.place();
      }

      onSectionUnload(event) {
        if (event.target !== this.section) {
          return;
        }

        this.restore();
      }

      place() {
        if (!this.card || !this.home) {
          return;
        }

        if (!this.layoutQuery.matches) {
          this.restore();
          return;
        }

        const main = document.querySelector('.recipe-body__main');
        const anchor =
          main?.querySelector(':scope > .recipe-note') ||
          main?.querySelector(':scope > .recipe-video') ||
          main?.querySelector(':scope > .recipe-body__method');

        if (!anchor || anchor.nextElementSibling === this.card) {
          return;
        }

        anchor.after(this.card);
      }

      restore() {
        if (!this.card || !this.home || this.card.parentNode === this.home) {
          return;
        }

        this.home.prepend(this.card);
      }
    },
  );
}
